export default __webpack_public_path__ + "static/Денежный поток 8-ca58650a1f54f8eda0e4cc331f3b24a1.jpg";